import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import RadialGradient from '@bubble-ui/primitive-radial-gradient';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationVerifyYourIdentity = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationVerifyYourIdentity',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_radial_21134_70072)",
    fillRule: "evenodd",
    d: "M37.68 66.48a35.584 35.584 0 0 0 19.81 5.98c19.75 0 35.77-16.01 35.77-35.77S77.24.93 57.49.93C37.74.93 21.72 16.94 21.72 36.7c0 9.96 4.07 18.97 10.64 25.45l5.32 4.33Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_21134_70072)",
    fillRule: "evenodd",
    d: "M40.12 76.57c-.92 1.15-5.59-1.07-10.44-4.96-4.85-3.88-8.03-7.96-7.12-9.11.92-1.15 5.59 1.07 10.44 4.96 4.85 3.89 8.04 7.96 7.12 9.11Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_21134_70072)",
    d: "m28.39 67.14-5.86-4.61L7.12 81.17c-3.57 4.52-2.81 10.99 1.64 14.51l1.53 1.22c4.47 3.53 10.94 2.77 14.46-1.68l15.5-18.74-6.47-5.09"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint3_linear_21134_70072)",
    fillRule: "evenodd",
    d: "M40.12 76.57c-.92 1.15-5.59-1.07-10.44-4.96-4.85-3.88-8.03-7.96-7.12-9.11.92-1.15 5.59 1.07 10.44 4.96 4.85 3.89 8.04 7.96 7.12 9.11Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#4A68FB",
    fillRule: "evenodd",
    d: "m37.91 66.36-4.08 5.03c-.14.17-.38.19-.55.06l-4.78-3.8a.385.385 0 0 1-.06-.55l3.93-4.94 5.54 4.2Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint4_linear_21134_70072)",
    d: "M57.2 65.9c16.193 0 29.32-13.127 29.32-29.32 0-16.193-13.127-29.32-29.32-29.32-16.193 0-29.32 13.127-29.32 29.32 0 16.193 13.127 29.32 29.32 29.32Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint5_linear_21134_70072)",
    d: "M61.1 34.89a7.83 7.83 0 1 0 0-15.66 7.83 7.83 0 0 0 0 15.66Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint6_linear_21134_70072)",
    fillRule: "evenodd",
    d: "M46.24 51.96c-1.79-3.81-.87-11.02-.87-11.02s-10.43-17.25-5.42-19.06c4.37-1.57 4.02 7.17 8.22 11.37 2.27 2.27 4.02 3.67 9.09 3.67 7.69 0 15.04 4.24 15.04 12.61 0 8.41-23.26 8.37-26.06 2.43Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(RadialGradient, {
    id: "paint0_radial_21134_70072",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(57.489 36.698) scale(35.769)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.531,
    stopColor: "#ACE9FC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#6678F5"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_21134_70072",
    x1: 17.192,
    x2: 108.751,
    y1: 84.762,
    y2: -13.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#4A68FB"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_21134_70072",
    x1: -16.263,
    x2: 60.167,
    y1: 113.559,
    y2: 47.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.241,
    stopColor: "#4A68FB"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.328,
    stopColor: "#506DFB"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.447,
    stopColor: "#627CFC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.585,
    stopColor: "#7F95FC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.738,
    stopColor: "#A8B7FD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.901,
    stopColor: "#DCE2FE"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear_21134_70072",
    x1: 17.192,
    x2: 108.751,
    y1: 84.762,
    y2: -13.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#4A68FB"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint4_linear_21134_70072",
    x1: 63.765,
    x2: 50.507,
    y1: 6.195,
    y2: 67.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.998,
    stopColor: "#5CE0FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint5_linear_21134_70072",
    x1: 73.105,
    x2: 43.393,
    y1: 7.046,
    y2: 56.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#ACE9FC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.955,
    stopColor: "#4961FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint6_linear_21134_70072",
    x1: 73.342,
    x2: 43.63,
    y1: 7.188,
    y2: 56.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#ACE9FC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.955,
    stopColor: "#4961FF"
  }))));
};
ColoredIllustrationVerifyYourIdentity.displayName = 'ColoredIllustrationVerifyYourIdentity';
export default withProvisionalOverrideFromContext(ColoredIllustrationVerifyYourIdentity);
//# sourceMappingURL=index.js.map